import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { useReviews } from '@/composables/_next/useReviews';
import { gtmPushEvent } from '~/helpers/gtm';
import AzCarousel from '~/components/_next/molecules/AzCarousel.vue';
import AzRecipeCard from '~/components/_next/molecules/AzRecipeCard.vue';
import { useUser } from '~/composables/_next/useUser';
import { useAuthenticatedAction } from '~/composables/useAuthenticatedAction';
import { useRecipesWishlists } from '~/composables/useRecipesWishlists';
export default /*#__PURE__*/_defineComponent({
  __name: 'RelatedRecipesOrganism',
  props: {
    relatedRecipes: null,
    description: null
  },
  setup: function setup(__props) {
    var props = __props;
    var _useReviews = useReviews(),
      fetchAllAverageReviews = _useReviews.fetchAllAverageReviews;
    var _useNuxt2App = useNuxt2App(),
      i18n = _useNuxt2App.i18n;
    var route = useRoute();
    function getCategoryTranslation(category) {
      var _category$toLowerCase;
      var translationKey = "rdp.recipeFamily.".concat((_category$toLowerCase = category.toLowerCase()) === null || _category$toLowerCase === void 0 ? void 0 : _category$toLowerCase.replace(/\s/g, ''));
      var translation = i18n.t(translationKey);
      return !translation || translation !== translationKey ? translation : category;
    }
    var _useLazyAsyncData = useLazyAsyncData('fetch-related-recipe-reviews', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _props$relatedRecipes;
        var recipeIds, reviews;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              recipeIds = (_props$relatedRecipes = props.relatedRecipes) === null || _props$relatedRecipes === void 0 ? void 0 : _props$relatedRecipes.map(function (recipe) {
                return recipe.recipeId;
              });
              _context.next = 3;
              return fetchAllAverageReviews(recipeIds);
            case 3:
              reviews = _context.sent;
              return _context.abrupt("return", reviews);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })), {
        server: false
      }),
      recipeReviews = _useLazyAsyncData.data;
    var recipes = computed(function () {
      return props.relatedRecipes.flatMap(function (recipe) {
        var _recipeReviews$value, _recipeReviews$value$, _recipeReviews$value2, _recipeReviews$value3;
        return [_objectSpread(_objectSpread({}, recipe), {}, {
          category: recipe.category && getCategoryTranslation(recipe.category),
          numReviews: (_recipeReviews$value = recipeReviews.value) === null || _recipeReviews$value === void 0 ? void 0 : (_recipeReviews$value$ = _recipeReviews$value[recipe.recipeId]) === null || _recipeReviews$value$ === void 0 ? void 0 : _recipeReviews$value$.count,
          rating: (_recipeReviews$value2 = recipeReviews.value) === null || _recipeReviews$value2 === void 0 ? void 0 : (_recipeReviews$value3 = _recipeReviews$value2[recipe.recipeId]) === null || _recipeReviews$value3 === void 0 ? void 0 : _recipeReviews$value3.averageRate,
          wishlisted: isInRecipesWishlists(recipe.recipeId)
        })];
      });
    });
    var relatedRecipesTitle = computed(function () {
      var _props$relatedRecipes2;
      return i18n.tc('related.recipes', (_props$relatedRecipes2 = props.relatedRecipes) === null || _props$relatedRecipes2 === void 0 ? void 0 : _props$relatedRecipes2.length);
    });
    var shortenedDescription = computed(function () {
      var _props$description;
      return (_props$description = props.description) === null || _props$description === void 0 ? void 0 : _props$description.substring(0, 100);
    });
    var _useUser = useUser(),
      isAuthenticated = _useUser.isAuthenticated;
    var _useAuthenticatedActi = useAuthenticatedAction(),
      doActionOrLogin = _useAuthenticatedActi.doActionOrLogin,
      navigateToOrLogin = _useAuthenticatedActi.navigateToOrLogin;
    var _useUiState = useUiState(),
      toggleAddRecipeToWishlistSidebar = _useUiState.toggleAddRecipeToWishlistSidebar;
    var _useRecipesWishlists = useRecipesWishlists(),
      isInRecipesWishlists = _useRecipesWishlists.isInRecipesWishlists,
      removeRecipeFromWishlist = _useRecipesWishlists.removeRecipeFromWishlist;
    function updateWishlist(recipe) {
      if (isAuthenticated.value) {
        var wishlisted = isInRecipesWishlists(recipe.recipeId);
        if (wishlisted) {
          removeRecipeFromWishlist(recipe.recipeId);
        } else {
          toggleAddRecipeToWishlistSidebar({
            contentfulId: recipe.recipeId,
            image: recipe.cover,
            name: recipe.title
          });
        }
      } else {
        navigateToOrLogin({
          nextRoutePath: route.path,
          previousRoutePath: route.path
        });
      }
    }
    function pushClickEvent(recipe) {
      gtmPushEvent('recipe', [{
        event: 'generic_event',
        event_category: 'engagement',
        event_action: 'click',
        event_label: 'recipe',
        event_name: 'generic_event',
        recipe: recipe.title
      }]);
    }
    return {
      __sfc: true,
      props: props,
      fetchAllAverageReviews: fetchAllAverageReviews,
      i18n: i18n,
      route: route,
      getCategoryTranslation: getCategoryTranslation,
      recipeReviews: recipeReviews,
      recipes: recipes,
      relatedRecipesTitle: relatedRecipesTitle,
      shortenedDescription: shortenedDescription,
      isAuthenticated: isAuthenticated,
      doActionOrLogin: doActionOrLogin,
      navigateToOrLogin: navigateToOrLogin,
      toggleAddRecipeToWishlistSidebar: toggleAddRecipeToWishlistSidebar,
      isInRecipesWishlists: isInRecipesWishlists,
      removeRecipeFromWishlist: removeRecipeFromWishlist,
      updateWishlist: updateWishlist,
      pushClickEvent: pushClickEvent,
      AzCarousel: AzCarousel,
      AzRecipeCard: AzRecipeCard
    };
  }
});